export const siteMode = {
  // Set to true to show the maintenance page for all visitors.
  maintenance: true,
};
